<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 5</h1>
          <div class="text-left">
            <p>Wales Stayed at Mold, the room was a little Moldy</p>
            <p>Do not use the windscreen wipers if the car is iced over, unless it is a hire car.</p>
            <p>A big drive through Wales looking for some Top Gear mountain drive that might not have been in Wales but Scotland!</p>
            <p>Had a desk but no chair so could not update the website!</p>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>